import { lazy, Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import classes from './index.module.scss';
import Header from '../../components/Header';
import useWindowSize from '../../hooks/useWindowSize';
const NavDesktop = lazy(() => import('../../components/NavDesktop'));

const MainLayout = () => {
  const [isMobile, setIsMobile] = useState(false);

  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    if (windowWidth && windowWidth < 500) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  return (
    <main className={classes.container}>
      <div className={classes.backgroundOne} />
      <div className={classes.backgroundTwo} />
      <Suspense fallback={<>...loading</>}>
        <NavDesktop />
      </Suspense>
      <section className={classes.mainContainer}>
        <Header isMobile={isMobile} />
        <Outlet />
      </section>
    </main>
  );
};

export default MainLayout;
